import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Flex,
} from "@chakra-ui/react";
import Collection from "./collection";
import { MdLayers } from "react-icons/md";

const Datasets = () => {
  

  return (
    <>
      <AccordionButton w="100%">
        <Box flex="1">
          <Flex alignItems="center">
            <Box as={MdLayers} mr={2} boxSize={6} />
            <Text fontSize="sm" fontWeight="bold" textTransform="uppercase">
              Layers
            </Text>
          </Flex>
        </Box>

        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel pb={4} display="flex" flexDir="column" minH={0}>
        <Collection />
      </AccordionPanel>
    </>
  );
};

export default Datasets;
